module.exports = __webpack_public_path__ + "img/Javascript-logo.dd60b11e.svg";